import(/* webpackMode: "eager" */ "/home/runner/work/play-web/play-web/web/apps/offspring/src/app/not-found.tsx");
